export default __webpack_public_path__ + "static/media/17c4e071.svg";